// extracted by mini-css-extract-plugin
export var closeButton = "_10-0";